<template>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar  " :class="!showSidebar ? 'collapse-sidebar' : ''">    
     
        <!-- Sidebar navigation-->
        <div class="sidebar-profile" v-if="showSidebar">
          <div class="row">

            <div class="col-12">
              <a href="#/profile">
                <b>{{ profile.fid }}</b>
                <p><small>{{ profile.eid }}</small></p>
              </a>
            </div>
          </div>


          <b-input-group size="sm" prepend="Periode : " variant="success" class="mb-0">
            <b-form-select size="sm" style="margin-bottom: 0;" v-model="selectedPeriode.periode_id"
              @change="switchPeriode()">
              <b-form-select-option value=""> -- Pilih -- </b-form-select-option>
              <b-form-select-option v-for="periode in listPeriode" :value="periode.periode_id"> {{ periode.periode }}
              </b-form-select-option>
            </b-form-select>
          </b-input-group>
        </div>
        <!-- Sidebar scroll-->
    <perfect-scrollbar>
       <div class="scroll-sidebar" :class="!showSidebar ? 'mini-sidebar' : ''">
        <nav class="sidebar-nav">
          <ul id="sidebarnav">
            <template v-for="menu in sidemenu">
              <li v-if="menu.type == 'header'" class="nav-small-cap"> <span>{{ menu.title }} </span></li>
              <li v-else>
                <template v-if="menu.sub.length > 0">

                  <a @click="toggle(menu)"
                    :class="{ 'has-arrow waves-effect waves-dark': menu.sub.length > 0, '': menu.color }"
                    aria-expanded="false">
                    <icon :name="menu.icon" class="md-size-1x mr-3  w-25" />
                    <span class="hide-menu"> {{ menu.title }} <span v-if="menu.module == 'kinerja'"
                        class="badge badge-danger" style="float: right">New</span> </span>
                  </a>
                  <ul v-if="menu.sub.length > 0" :aria-expanded="false" :class="menu.collapse">
                    <template v-for="child in menu.sub">
                      <li>
                        <a :href="'#/' + child.module">
                          {{ child.title }}

                        </a>
                      </li>
                    </template>
                  </ul>
                </template>
                <template v-else>
                  <a :href="'#/' + menu.module" :class="menu.color">
                    <icon :name="menu.icon" class="md-size-1x mr-3  w-25" />
                    <span class="hide-menu"> {{ menu.title }} </span>
                  </a>

                </template>

              </li>
            </template>
          </ul>
        </nav>

        <!-- End Sidebar scroll-->
        <!-- End Sidebar navigation -->


        <!-- End Sidebar navigation -->
      </div>
    </perfect-scrollbar>
    <!-- End Sidebar scroll-->
  </aside>
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
</template>

<script>
import { mapState, mapMutations } from "vuex";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    VuePerfectScrollbar
  },
  computed: {
    ...mapState({
      showSidebar: state => state.showSidebar,
      //  menuItem: state => state.menuItem
    })
  },
  data() {
    return {
      menuItem: [],
      profile: {
        gid: 3,
        opd: '0000'
      },
      listPeriode: [],
      selectedPeriode: {
        periode_id: localStorage.getItem('periode')
      },
      menu_utama: [
        { type: 'header', title: 'Dashboard Utama', module: '', icon: '' },
        { type: 'link', title: 'Dashboard & Statistik', module: 'dashboard', icon: 'chart-bar', color: 'green', collapse: 'collapse', sub: [
            { type: 'link', title: 'Proses Bisnis ', module: 'dash/main', icon: 'pie' } ,
          ]
        },        
        {
          type: 'link', title: ' Capaian ( Makro ) ', module: 'kosong_1', icon: 'chart-pie', color: '5', collapse: 'collapse', sub: [
            { type: 'link', title: 'Satistik Akip ( LKE ) ', module: 'stat_akip', icon: 'pie' } , 
            { type: 'link', title: 'Capaian Kinerja Kabupaten', module: 'stat_capaian', icon: 'pie' } ,
            { type: 'link', title: 'Sasaran Strategis & IKU Bupati', module: 'stat_pk_bupati', icon: 'pie' } ,
            
             { type: 'link', title: 'Sasaran Strategis Perangkat Daerah', module: 'stat_perjanjian', icon: 'pie' } ,
             { type: 'link', title: 'Capaian & Efisiensi Anggaran', module: 'stat_efisiensi', icon: 'pie' } 
          ]
        },
        {
          type: 'link', title: 'Headline & Raport Capaian', module: 'kosong_2', icon: 'duplicate', color: '5', collapse: 'collapse', sub: [
            { type: 'link', title: 'Raport AKIP PD', module: 'raport_sakip', icon: 'user' },
            { type: 'link', title: 'Raport Triwulan PD', module: 'raport_iku', icon: 'sitemap' },
            { type: 'link', title: 'Raport & Predikat', module: 'raport', icon: 'user' },
           /* { type: 'link', title: 'Diagram Rapor Kinerja', module: 'rank/diagram', icon: 'pie' } , */
            { type: 'link', title: 'Data Rapor Kinerja', module: 'rank/raport', icon: 'pie' } ,
          ]
        },
        
        /*
        { type : 'link' , title : 'Raport & Predikat' , module : 'raport' , icon : 'document-text' , collapse : 'collapse' , sub : []},
        { type : 'link' , title : 'Raport IKU PD' , module : 'raport_iku' , icon : 'document-text' , collapse : 'collapse' , sub : []},
        { type : 'link' , title : 'Raport AKIP PD' , module : 'raport_sakip' , icon : 'document-text' , collapse : 'collapse' , sub : []},
        */
      //  { type: 'link', title: 'Pohon Kinerja Daerah', module: 'pohon_kinerja', icon: 'share', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Pohon Kinerja PD', module: 'pohon_kinerja', icon: 'share', collapse: 'collapse', sub: [] },
        // { type: 'link', title: 'Laporan AKIP PD', module: 'laporanAkip', icon: 'calendar', collapse: 'collapse', sub: [] },
        { type: 'header', title: 'RPJMD , RENSTRA & RENJA', module: '', icon: '' },
        {
          type: 'link', title: 'RPJMD / RPD ', module: 'kosong', icon: 'duplicate', color: '5', collapse: 'collapse', sub: [
            { type: 'link', title: 'Periode RPJMD', module: 'prolap/periode', icon: 'sitemap' },
            { type: 'link', title: 'Tabulasi RPJMD', module: 'rpjmd', icon: 'user' }
          ]
        },
        { type: 'link', title: 'Tabulasi RENSTRA', module: 'renstra', icon: 'table', color: 'light-5', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Tabulasi RENJA & DPA', module: 'renja', icon: 'tag', color: '5', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Trajectory Target', module: 'target', icon: 'clock', color: '5', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Perjanjian Kinerja', module: 'perjanjian', icon: 'user', color: '5', collapse: 'collapse', sub: [] },
        { type: 'header', title: 'Kinerja & Anggaran', module: '', icon: '' },
        
         { type: 'link', title: 'Monitoring Lap Realisasi', module: 'verifikasi', icon: 'bookmark', color: '5', collapse: 'collapse', sub: [] },
         { type: 'link', title: 'Laporan Anggaran', module: 'anggaran', icon: 'table', color: '5', collapse: 'collapse', sub: [] }, 
        { type: 'link', title: 'Realisasi Kinerja Anggaran', module: 'realisasi', icon: 'calendar', color: '5', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Realisasi  Bulanan', module: 'evaluasi', icon: 'bookmark', color: '5', collapse: 'collapse', sub: [] },



      ],
      menu_fasil: [
        { type: 'header', title: 'Dashboard Utama', module: '', icon: '' },
        { type: 'link', title: 'Dashboard', module: 'dashboard', icon: 'chart-bar', color: 'green', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Pohon Kinerja', module: 'pohon_kinerja', icon: 'share', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Laporan AKIP PD', module: 'laporanAkip', icon: 'table', collapse: 'collapse', sub: [] },
        
        {
          type: 'link', title: 'Raport Kinerja', module: 'kosong_3', icon: 'chart-pie', color: '5', collapse: 'collapse', sub: [
          //  { type: 'link', title: 'Diagram Rapor Kinerja', module: 'rank/diagram', icon: 'pie' } , 
            { type: 'link', title: 'Data Rapor Kinerja', module: 'rank/raport', icon: 'pie' } ,
            { type: 'link', title: 'Rangking Raport Kinerja', module: 'raport', icon: 'pie' } 
          ]
        },
        
        // { type: 'link', title: 'Raport AKIP PD', module: 'raport_sakip', icon: 'share', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Tabulasi RENSTRA', module: 'renstra', icon: 'table', color: 'light-5', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Tabulasi RENJA & DPA', module: 'renja', icon: 'tag', color: '5', collapse: 'collapse', sub: [] },
        { type: 'header', title: 'Kinerja & Anggaran', module: '', icon: '' },
        { type: 'link', title: 'Trajectory Target', module: 'target', icon: 'clock', color: '5', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Perjanjian Kinerja', module: 'perjanjian', icon: 'user', color: '5', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Monitoring Lap. Realisasi', module: 'verifikasi', icon: 'bookmark', color: '5', collapse: 'collapse', sub: [] },
         { type: 'link', title: 'Laporan Anggaran', module: 'anggaran', icon: 'bookmark', color: '5', collapse: 'collapse', sub: [] },
       //   { type: 'link', title: 'Laporan Bulanan', module: 'evaluasi', icon: 'table', color: '5', collapse: 'collapse', sub: [] },
        //  { type: 'link', title: 'Realisasi Kinerja Anggaran', module: 'realisasi', icon: 'calendar', color: '5', collapse: 'collapse', sub: [] },
       
       


      ],
      menu_inspektorat: [
        { type: 'header', title: 'Dashboard Utama', module: '', icon: '' },
        { type: 'link', title: 'Dashboard', module: 'dashboard', icon: 'chart-bar', color: 'green', collapse: 'collapse', sub: [] },
        { type: 'link', title: 'Raport AKIP PD', module: 'raport_sakip', icon: 'bookmark', collapse: 'collapse', sub: [] },
       { type: 'link', title: 'Pohon Kinerja', module: 'pohon_kinerja', icon: 'share', collapse: 'collapse', sub: [] },
      ],
      sidemenu: []
    }
  },
  mounted() {
    this.profile = JSON.parse(localStorage.getItem('profile'));
    this.listPeriode = JSON.parse(localStorage.getItem('listPeriode'));
    console.log(this.profile)
    if (this.profile.gid == '1') {
      this.sidemenu = this.menu_utama
    } else if (this.profile.gid == '3') {
      this.sidemenu = this.menu_inspektorat
    } else {
      this.sidemenu = this.menu_fasil;
    }

    this.opd = this.profile.opd
    this.fetchData()
  },
  methods: {
    ...mapMutations({
      // toggleDropdown: "toggleDropdown"
    }),
    toggleDropdown(index) {
      this.menuItem[index].collapsed = !this.menuItem[index].collapsed;
    },
    toggle(currentMenu) {

      // if (currentMenu.type === 'link') {
      console.log(currentMenu.module)
      this.sidemenu.forEach(element => {

        if (element.module == currentMenu.module) {
          console.log(currentMenu.module)

          currentMenu.collapse = (currentMenu.collapse == 'collapse' ? '' : 'collapse');
        } else {
          // element.collapse = '';
        }
      });
      //}
    },
    fetchData() {


    },
    switchPeriode() {
      let periode_id = this.selectedPeriode.periode_id
      let selectedPeriode = []
      let periode
      this.listPeriode.forEach(function (elm) {
        if (elm.periode_id == periode_id) {
          selectedPeriode = elm
          periode_id = elm.periode_id
        }
      })
      localStorage.setItem('periode', periode_id)
      localStorage.setItem('onPeriode', JSON.stringify(selectedPeriode))
    }
  }
};
</script>

<style scoped>
.input-group-sm>.custom-select {
  font-size: 10px;
}

.sidebar-profile .input-group-sm>.input-group-prepend>.input-group-text {
  font-size: 10px;
  background: #374154;
  color: white;
}

.collapse-sidebar {
  width: 70px;
}

.collapse-sidebar #sidebarnav>li>a.has-arrow:after {
  display: none;
}

.svg-inline--fa {
  font-size: 18px;
}

.left-sidebar svg {
  padding: 2px;

}

.left-sidebar a.red svg {

  color: #ff0000;
}

.left-sidebar a.orange svg {

  color: #ff9900;
}

.left-sidebar a.purple svg {

  color: #6A1B9A;
}

.left-sidebar a.blue svg {

  color: #398bf7;
}

.left-sidebar a.light-green svg {

  color: #558B2F;
}

.left-sidebar a.pink svg {

  color: #FF80C0;
}

.ps {
  height: calc(100vh - 127px);
}

.w-20 {
  width: 20px;
}

.w-25 {
  width: 23px !important;
}

.w-30 {
  width: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Sidebar.vue